var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "CheckBox" }, [
    !_vm.data.answered
      ? _c("div", [
          _c("div", { staticClass: "question clear" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              _vm.data.rule && _vm.data.itemList
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(
                      "最多选" +
                        _vm._s(
                          _vm.data.rule.length || _vm.data.itemList.length
                        ) +
                        "个"
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            _vm._l(_vm.data.itemList, function(i, index) {
              return _c("div", { key: i.itemNo + index, staticClass: "item" }, [
                _c("div", { staticClass: "item_left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: i.bol,
                        expression: "i.bol"
                      }
                    ],
                    attrs: { type: "checkbox", disabled: _vm.disabledBol },
                    domProps: {
                      checked: Array.isArray(i.bol)
                        ? _vm._i(i.bol, null) > -1
                        : i.bol
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = i.bol,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && _vm.$set(i, "bol", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  i,
                                  "bol",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(i, "bol", $$c)
                          }
                        },
                        _vm.objChange
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "item_left_itemNo" }, [
                    _vm._v(_vm._s(i.itemNo) + ". ")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item_right" },
                  _vm._l(JSON.parse(i.itemDes ? i.itemDes : "{}"), function(o) {
                    return _c("div", { key: JSON.stringify(o) }, [
                      _c("span", { staticClass: "span" }, [
                        _vm._v(_vm._s(o.txt))
                      ])
                    ])
                  }),
                  0
                )
              ])
            }),
            0
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "question clear" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              _vm.data.rule && _vm.data.itemList
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(
                      "（最多选" +
                        _vm._s(
                          _vm.data.rule.length || _vm.data.itemList.length
                        ) +
                        "个）"
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            _vm._l(_vm.data.itemList, function(i, index) {
              return _c("div", { key: i.itemNo + index, staticClass: "item" }, [
                _c("div", { staticClass: "item_left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: i.bol,
                        expression: "i.bol"
                      }
                    ],
                    attrs: { type: "checkbox", disabled: _vm.disabledBol },
                    domProps: {
                      checked: Array.isArray(i.bol)
                        ? _vm._i(i.bol, null) > -1
                        : i.bol
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = i.bol,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && _vm.$set(i, "bol", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  i,
                                  "bol",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(i, "bol", $$c)
                          }
                        },
                        _vm.objChange
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "item_left_itemNo" }, [
                    _vm._v(_vm._s(i.itemNo) + ". ")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item_right" },
                  [
                    _vm._l(JSON.parse(i.itemDes ? i.itemDes : "{}"), function(
                      o
                    ) {
                      return _c("div", { key: JSON.stringify(o) }, [
                        _c("span", { staticClass: "span" }, [
                          _vm._v(_vm._s(o.txt))
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    i.answerCount
                      ? _c("div", { staticClass: "progress" }, [
                          _c("div", { staticClass: "progress_left" }, [
                            _vm._v(_vm._s(i.answerCount) + "票")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "progress_box" },
                            [
                              _c("el-progress", {
                                attrs: {
                                  percentage:
                                    i.answerPercentage.split("%")[0] * 1,
                                  color: "#2b6fff"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            }),
            0
          )
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "answerObj none" }, [
      _vm._v(_vm._s(_vm.answerObj))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "isNecessary none" }, [
      _vm._v(_vm._s(_vm.data.rule ? (_vm.data.rule.isNecessary ? 1 : 0) : 0))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-33f8d1e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-33f8d1e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/topic/public/check-box.vue
// module id = null
// module chunks = 